export enum DashboardHttpPaths {
  shiftsCount = '/api/v1.0/staff/shifts/summaries/count',
  payRates = '/api/v1.0/staff/pay-rates',
}
